import type { GetAudienceQuery } from '../../../graphql/query/audiences/GetAudience.generated';
import { MatchingOperator } from '../AudienceForm/constants';
import type { AudienceForm } from '../AudienceForm/types';
import { getInitialEditValues } from '../AudienceForm/utils/getInitialEditValues';

const emptyForm: AudienceForm = {
  name: '',
  description: '',
  account_id: '',
  export_type: null,
  export_targets: {
    ctv: false,
    device: false,
    id5: false,
    idl: false,
    ip: false,
  },
  direct_audience_provider: null,
  normalized_definition: {
    excludes: {
      operator: MatchingOperator.INTERSECTION,
      groups: [],
    },
    includes: {
      operator: MatchingOperator.INTERSECTION,
      groups: [],
    },
  },
  audience_share: [],
};

export const mapToAudienceForm = (data: GetAudienceQuery | null): AudienceForm => {
  if (!data?.audience_by_pk) {
    return emptyForm;
  }

  return getInitialEditValues(data.audience_by_pk);
};
